import type { DetailSectionId } from './types';

export function getDetailFieldKey(sectionId: DetailSectionId, label: string) {
  return `${sectionId}:${label}`;
}
